/**
 * carryingIntention.js — a one-shot handoff from Rituals (or Home) to
 * the Journal page, carrying today's selected INTENTION rather than an
 * affirmation.
 *
 * Mirrors the architecture of `carryingAffirmation.js`:
 *   • "Reflect in Journal →" under TODAY'S INTENTION stashes the
 *     intention in localStorage and routes to /journal.
 *   • The Journal page reads it ONCE on mount via
 *     `consumeCarryingIntention()` (which clears the key), so a plain
 *     visit to Journal never renders the contextual panel.
 *   • Nothing writes a journal entry on the member's behalf.
 *
 * Intentions and affirmations are kept in separate keys so each surface
 * tells the right story when it appears over the composer.
 */
const KEY = "n8one.carrying-intention.v1";

export function setCarryingIntention({ text, category }) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ text: text || "", category: category || "", at: Date.now() }),
    );
  } catch { /* noop */ }
}

/** Read and clear in a single call. Returns null if nothing was set. */
export function consumeCarryingIntention() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    if (!parsed?.text) return null;
    return parsed;
  } catch { return null; }
}
